<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TgNi0S/tc-custom/9781453251973.jpg?1734405497814" alt="This image is the cover for the book Gypsy, The St-Cyr and Kohler Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gypsy, The St-Cyr and Kohler Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>An international safecracker steals diamonds destined for the Reich</b>A tip comes in to the Gestapo, warning of an impending burglary at the Paris Ritz. The target is the room of a special attaché to the German Ministry of Production, where a safe contains a cache of diamonds intended for use in arms manufacture. When inspectors Jean-Louis St-Cyr and Hermann Kohler arrive, backed up by a Berlin cop, the safe is intact. But when they turn the dial to inspect its contents, it explodes, leaving the policemen shaken but unharmed, and ruining one of the finest suites in the Ritz. The burglar has already come and gone, leaving the safe rigged with nitroglycerin as a surprise for his pursuers. His codename is Gypsy, and he has deviled the Reich for years. St-Cyr and Kohler will do their best to unmask him, but as they learned long ago, no crime is simple when the victims are servants of the Thousand Year Reich.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. Robert Janes
      </h2>
      
      <p class="authorDescription body article">J. Robert Janes (b. 1935) is a mystery author best known for writing historical thrillers. Born in Toronto, he holds degrees in mining and geology, and worked as an engineer, university professor, and textbook author before he started writing fiction. He began his career as a novelist by writing young adult books, starting with <i>The Odd-Lot Boys and the Tree-Fort War</i> (1976). He wrote his last young adult novel, <i>Murder in the Market</i>, in 1985, by which time he had begun writing for adults, starting with the four-novel Richard Hagen series.&#160;In 1992, Janes published <i>Mayhem</i>, the first in the long-running St-Cyr and Kohler series for which he is best known. These police procedurals set in Nazi-occupied France have been praised for the author&rsquo;s attention to historical detail, as well as their swift-moving plots. The thirteenth in the series, <i>Bellringer</i>, was published in 2012.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?276c4b9e